export default __webpack_public_path__ + "static/RoslindaleVariable-VF[Display]-no-hints-117d2e9688978efbe120d601dd47f9a2.woff";